import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ProjectItem = ({ data }) => {
    const cate = data.categories.map((value, idx) => {
        return (
            <span className="d-inline" key={idx}>
                {value}
                {idx !== data.categories.length - 1 && " , "}
            </span>
        );
    });
    return (
        <div className="single-project">
            <div className="project-images">
                <Link
                    to={process.env.PUBLIC_URL + `/project-detalis/${data.id}`}
                >
                    <picture>
                        <source
                            srcSet={
                                process.env.PUBLIC_URL +
                                data.media.thumb.replace(
                                    /\.(jpg|jpeg|png)$/i,
                                    ".webp"
                                )
                            }
                            type="image/webp"
                        />
                        <img
                            src={process.env.PUBLIC_URL + data.media.thumb}
                            alt={data.title}
                            loading="lazy"
                            decoding="async"
                            width="600"
                            height="450"
                        />
                    </picture>
                </Link>
            </div>
            <div className="project-content">
                <h4 className="title">
                    <Link
                        to={
                            process.env.PUBLIC_URL +
                            `/project-detalis/${data.id}`
                        }
                    >
                        {data.title}
                    </Link>
                </h4>
                <p className="category">{cate}</p>
            </div>
        </div>
    );
};

ProjectItem.propTypes = {
    data: PropTypes.object,
};

export default ProjectItem;
